import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { currentTable } from "../../../../app/viewManager.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { validateData, getContent, deleteRecord } from "./tableManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";

export async function loadUsers() {
    const users = await apiFetch("Users");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(users)) { currentTable.replaceData([]); return; }
    currentTable.setData(users);
    updateFilterOptions(currentTable.getData(), currentTable);
}

function markEmailNotFound(email) {
    const content = getContent();
    const emailInput = content?.querySelector("#dropdownEmail");
    if (emailInput) {
        if (typeof emailInput.setError === 'function') emailInput.setError();
        else { emailInput.style.borderColor = 'red'; emailInput.addEventListener('input', () => { emailInput.style.borderColor = ''; }, { once: true }); }
    }
    toast(`Der Nutzer "${email}" konnte nicht in Azure gefunden werden`, "error");
}

async function collectData() {
    const content = getContent();
    if (!content) return null;

    const employmentType = content.querySelector("#dropdownEmploymentType")?.getValue?.() || null;

    return {
        Email:          content.querySelector("#dropdownEmail")?.getValue?.() ?? "",
        RoleId:         content.querySelector("#dropdownRole")?.getValue?.()  ?? null,
        TeamId:         content.querySelector("#dropdownTeam")?.getValue?.()  || null,
        EmploymentType: employmentType !== null ? Number(employmentType) : null
    };
}

export async function createUser() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newUser = await apiFetch("Users", "POST", collectedData, { silentNotFound: true, silentConflict: true });
    if (newUser === 404) {
        markEmailNotFound(collectedData.Email);
        return true;
    }
    if (newUser === 409) {
        toast(`Der Nutzer "${collectedData.Email}" existiert bereits`, "error");
        return true;
    }
    if (isErrorResult(newUser)) return newUser ? true : undefined;

    if (currentTable) {
        await currentTable.addRow(newUser.user, true);
        updateFilterOptions(currentTable.getData(), currentTable);
    }
    document.dispatchEvent(new CustomEvent('user-data-changed', { detail: { action: 'created', user: newUser, skipReload: true } }));
    toast("Benutzer erfolgreich hinzugefügt!", "success");
    return newUser;
}

export async function editUser(userId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedUser = await apiFetch(`Users/${userId}`, "PATCH", collectedData, { silentNotFound: true, silentConflict: true });
    if (updatedUser === 404) {
        markEmailNotFound(collectedData.Email);
        return true;
    }
    if (updatedUser === 409) {
        toast(`Der Nutzer "${collectedData.Email}" existiert bereits`, "error");
        return true;
    }
    if (isErrorResult(updatedUser)) return updatedUser ? true : undefined;

    if (currentTable) {
        await currentTable.updateOrAddData([updatedUser.user]);
        updateFilterOptions(currentTable.getData(), currentTable);
    }
    document.dispatchEvent(new CustomEvent('user-data-changed', { detail: { action: 'updated', user: updatedUser, skipReload: true } }));
    toast("Benutzer erfolgreich aktualisiert!", "success");
    return updatedUser;
}

export const deleteUser = (userId) => deleteRecord("Users", userId, "Benutzer erfolgreich gelöscht!",
    () => document.dispatchEvent(new CustomEvent('user-data-changed', { detail: { action: 'deleted', id: userId } }))
);
